'use strict';
const _ = require("lodash"),
    $ = require("jquery"),
    Backbone = require("backbone")
    ;

var base = function (attrs, options) {
      options = options || {};
      this.cms = options.cms;
      this.textKey = options.textKey;

      Backbone.Model.apply(this, arguments);
};
_.extend(base.prototype, Backbone.Model.prototype, {
     defaults: function(){
        return {
            copy: {},
            uid: ''
        }
     }
    ,initialize: function (attrs, options) {
      if(this.cms){
          this.listenTo(this.cms, 'change:text', function (model, value) {
              this.updateCopy(model, value)
          }.bind(this))
      }
    }
    /**
     *
     */
    , fetch: function(options) {
        console.log('The Base model does not support "fetch"');
    }
    /**
     *
     */
    , save: function(attrs, options) {
        console.log('The Base model does not support "save"');
    }
    /**
     *
     */
    , destroy: function(options) {
        options = options ? _.clone(options) : {};
        var model = this;
        var wait = options.wait;

        var destroy = function() {
          model.stopListening();
          model.trigger('destroy', model, model.collection, options);
        };

        if (!wait) destroy();

        console.log('The Base model does not support "destroy"');
    }
    /**
     * [updateCopy description]
     * @param  {[type]} model [description]
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    , updateCopy: function (model, value) {
        if(!this.textKey){
          return;
        }
        
        this.set({
          copy: value[this.textKey]
        });
    }
});
base.extend = Backbone.Model.extend;

module.exports = base;


// WEBPACK FOOTER //
// ./app/scripts/models/base.js